import { Link, Outlet } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import { useScrollTop } from "@/hooks/useScrollTop";

const MainLayout = () => {
  useScrollTop();

  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <Navbar />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <Link
        to="/search"
        aria-label="前往检索页"
        className="fixed bottom-6 right-5 z-40 flex h-12 w-12 items-center justify-center rounded-full bg-primary-500 text-background-50 shadow-lg transition-transform hover:scale-105 md:hidden"
      >
        <i className="ri-search-line text-xl" />
      </Link>
    </div>
  );
};

export default MainLayout;